var React = require('react');

function Beer (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M368 96h-48V56a24 24 0 0 0-24-24H24A24 24 0 0 0 0 56v400a24 24 0 0 0 24 24h272a24 24 0 0 0 24-24v-42.11l80.61-36a80.08 80.08 0 0 0 47.39-73V176a80.09 80.09 0 0 0-80-80zM128 368a16 16 0 0 1-32 0V144a16 16 0 0 1 32 0zm96 0a16 16 0 0 1-32 0V144a16 16 0 0 1 32 0zm160-63.14a16 16 0 0 1-9.48 14.61L320 343.8V160h48a16 16 0 0 1 16 16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M208 128a16 16 0 0 0-16 16v224a16 16 0 0 0 32 0V144a16 16 0 0 0-16-16zm-96 0a16 16 0 0 0-16 16v224a16 16 0 0 0 32 0V144a16 16 0 0 0-16-16z","className":"fa-primary","key":2})]);
}

Beer.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Beer;

Beer.default = Beer;
